export default function SkeletonTable() {
  return (
    <section className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
      {/* Table Header */}
      <div className="p-4 border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/50 flex gap-4">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="skeleton h-4 w-full rounded-md" />
        ))}
      </div>

      {/* Table Body Rows */}
      <div className="divide-y divide-slate-100 dark:divide-slate-800">
        {[...Array(8)].map((_, rowIndex) => (
          <div key={rowIndex} className="p-4 flex gap-4 items-center">
            {/* Row Cells */}
            <div className="skeleton h-4 w-[15%] rounded-md" />
            <div className="skeleton h-4 w-[25%] rounded-md" />
            <div className="skeleton h-4 w-[20%] rounded-md" />
            <div className="skeleton h-4 w-[15%] rounded-md" />
            <div className="skeleton h-4 w-[10%] rounded-md" />
            <div className="skeleton h-8 w-[15%] rounded-full" />{" "}
            {/* Action Button/Badge */}
          </div>
        ))}
      </div>
    </section>
  );
}
